
















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Select extends Vue {
  public $refs!: { select: HTMLFormElement }

  @Prop({ type: Array, default: [] })
  options!: []

  @Prop({ type: String, default: '' })
  value!: ''

  onChange(e: any) {
    this.$emit('input', e.target.value)
  }

  mounted() {
    // console.log(this.$refs.select.value)
    // this.$emit('input', e.target.value)
  }
}
